// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NnEWDl1qIFFMXRxEd8hIe","visible":"_2-2Irlz4rNK6ZJX4oAS-dk","wrapper":"_52b60WtM7z9oiArKLQ4IZ","content":"_39_jvKg4P0FXGnrUXxjcYB","heading":"BeT4VL42ghY7cTmR77jTq"};